import { LabelData } from './label-data';

export class Label {
	id: string;
	name: string;
	userId: string;
	companyId: string;
	readOnly?: boolean;

	constructor(data: LabelData & { isSelected?: boolean; readOnly?: boolean }) {
		this.id = data.id;
		this.name = data.name;
		this.userId = data.user_id;
		this.companyId = data.company_id;
		this.readOnly = data.readOnly ?? false;
	}
}
